// components/MenuComponent.jsx
'use client';

import { useState } from 'react';
import styles from './MenuHeaderHero.module.scss';
import Link from 'next/link';
import Image from 'next/image';

const MenuHeaderHero = ({
  desktopVideoSrc,
  mobileVideoSrc,
  title,
  subtitle,
  button1Text,
  button2Text,
  button3Text,
  button4Text,
  showContent = true,
  showHeroOverlay = false,
}) => {
  const links = [
    { href: '/steakhouse-menu/our-food-menu', text: button1Text },
    { href: '/steakhouse-menu/set-menu', text: button2Text },
    { href: '/steakhouse-menu/our-winelist', text: button3Text },
    { href: '/steakhouse-menu/four-brothers', text: button4Text },
  ];

  const [currentActiveLink] = useState(() => {
    if (typeof window === 'undefined') return null;
    const currentPath = window.location.pathname;
    return links.find((link) => link.href === currentPath) || null;
  });

  return (
    <div className={styles.menuContainer}>
      <video className={styles.backgroundVideo} autoPlay loop muted>
        <source src={desktopVideoSrc} type="video/mp4" media="(min-width: 768px)" />
        <source src={mobileVideoSrc} type="video/mp4" media="(max-width: 767px)" />
        Your browser does not support the video tag.
      </video>

      {/* New hero overlay */}
      {showHeroOverlay && (
        <div className={styles.heroOverlay}>
          <div className={styles.darkOverlay}></div>

          {/* Centered logo */}
          <div className={styles.logoContainer}>
            <Image
              src="/images/static/tnt-hero-logo.svg"
              alt="Turn n Tender Steakhouse Logo"
              width={600}
              height={600}
              className={styles.heroLogo}
            />
          </div>

          {/* CTA buttons */}
          <div className={styles.ctaButtons}>
            <Link href="/news" className={styles.ctaButton}>
             LATEST NEWS
            </Link>
            <Link href="/steakhouse-menu/our-food-menu" className={styles.ctaButton}>
              OUR MENU
            </Link>
            <Link href="https://locations.turnntender.co.za/" target="_blank" rel="noopener noreferrer" className={styles.ctaButton}>
              LOCATIONS
            </Link>
          </div>

          {/* Grilling Since '77 badge */}
          <div className={styles.grillingBadge}>
            <Image
              src="/images/static/grilling-since-77.svg"
              alt="Grilling since 77"
              width={150}
              height={60}
              className={styles.grillingImage}
            />
          </div>
        </div>
      )}

      {showContent && (
        <div className={styles.overlay}>
          <h1 className={styles.h1}>
            {title} <span className={styles.dash}>{subtitle}</span>
          </h1>
          <div className={styles.buttonGroup}>
            {links.map((link, index) => (
              <Link key={index} href={link.href}>
                <button
                  className={`${styles.button} ${
                    currentActiveLink && currentActiveLink.href === link.href
                      ? styles.active
                      : ''
                  }`}
                >
                  {link.text}
                </button>
              </Link>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default MenuHeaderHero;


